import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import { TextLink } from "../../components/UI/TextLink/TextLink";
import classes from './CalendarManagement.css';

import axios from 'axios';
import Alert from 'react-s-alert';
import { WithContext as ReactTags } from 'react-tag-input';
import { useMobile, backendEndpoint } from '../../store/utility';

// import TextLink from '../../components/UI/TextLink/TextLink';

const KeyCodes = {
    comma: 188,
    enter: 13,
  };

const delimiters = [KeyCodes.comma, KeyCodes.enter];


class CalendarManagement extends React.Component{

    constructor(props){
        super(props);
        this.calendarNoteInput = React.createRef(); 
        this.state = {
            useContactMethodOption: false,
            tags: [
                // { id: "Cell Phone", text: "Cell Phone" },
            ],
            suggestions: [
                { id: "Cell Phone", text: "Cell Phone" },
                { id: "Facetime", text: "Facetime" },
                { id: "Facebook", text: "Facebook" },
                { id: "WeChat", text: "WeChat" },
                { id: "WhatsApp", text: "WhatsApp" },
                { id: "Line", text: "Line" },
                { id: "Viber", text: "Viber" },
                { id: "Kakaotalk", text: "Kakaotalk" },
                { id: "Skype", text: "Skype" },
                { id: "IMO", text: "IMO" },
                { id: "Slack", text: "Slack" },
                { id: "Zoom", text: "Zoom" },
                { id: "Google Meet", text: "Google Meet" },
            ]
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.authToken !== null){
            this.loadCalendar();
        }
        else {
            // in case of a refresh page, wait for 100 ms until authToken retrieved
            setTimeout(()=> { 
                this.loadCalendar();
            }, 100);
        }
    }

    loadCalendar = () => {
        let url = backendEndpoint + 'calendar/' + this.props.match.params.calendar_id + '/';
        axios.get(url, {
            headers: {'Authorization': 'Token '+ this.props.authToken}
            })
            .then(response => {
                this.calendarNoteInput.current.value = response.data.note;
                this.setState({
                    tags: response.data.contact_method_options, 
                    useContactMethodOption: response.data.contact_method_options.length > 0
                });
            })
            .catch(err => {
                Alert.error('failed to load calendar');
            });
    }

    handleSave = () => {
        let url = backendEndpoint + 'calendar/' + this.props.match.params.calendar_id + '/set_calendar_setting/';
        let calendarCustomData = {
            note: this.calendarNoteInput.current.value.trim(),
            contact_method_options: this.state.tags,
        }
        axios.post(url, calendarCustomData, {
            headers: {'Authorization': 'Token '+ this.props.authToken}
            })
            .then(response => {
                Alert.info('Changes saved');
            })
            .catch(err => {
                Alert.error('failed to save your changes');
            });
    }

    handleViewCalendar = () => {
        window.location.href = "/view-my-calendar/" + this.props.match.params.calendar_id;
    }

    handleBackToProfile = () => {
        window.location.href = "/profile/";
    }

    handleDelete(i) {
        const { tags } = this.state;
        this.setState({
         tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {
        this.setState(state => ({ tags: [...state.tags, tag] }));
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    handleContactMethodCheck = () => {

        if (!this.state.useContactMethodOption === true) {
            this.setState({tags: [{ id: "Cell Phone", text: "Cell Phone" }]})
        }
        else if (!this.state.useContactMethodOption === false) {
            this.setState({tags: []})
        }
        this.setState({useContactMethodOption: !this.state.useContactMethodOption});
    }


    render(){

        let inputSize;
        if (useMobile()===true) {
            inputSize = 'none';
        }
        else {
            inputSize = 'none';
        }

        const { tags, suggestions } = this.state;

        return (

            <div className={classes.CalendarManagement}>
                <Helmet>
                    <title>Calendar Customization | BookMeeY</title>
                    <meta name="description" content="Customized your BookMeeY calendar" />
                </Helmet>

                <div className={classes.CalendarManagementContent}>
                <Container>

                <div className={classes.OptionBlock}>
                <Form>
                    <Row>
                        <Col>
                            <Form.Group controlId="info">
                                <Form.Label><b>Calendar Note</b>
                                <Form.Text className="text-muted">
                                    This is optional, if you have a calendar note, this will show on the top of your BookMeeY calendar.
                                </Form.Text>
                                </Form.Label>
                                <Form.Control ref={this.calendarNoteInput} as="textarea" rows="4" />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>  
                </div>

                <div className={classes.OptionBlock}>
                <Form>
                    <Row>
                        <Col>
                        <Form.Label>
                        <b>Prefered Contact Method</b>
                        <Form.Text className="text-muted">
                            Ask for preferred contact method during booking. By default this question is disabled.
                        </Form.Text>
                        </Form.Label>
                        <div className={classes.Checkbox}>
                            <Form.Check 
                                onChange={this.handleContactMethodCheck}
                                checked={this.state.useContactMethodOption}
                                custom
                                type="checkbox"
                                id={1}
                                label="Yes, please ask for preferred contact method"
                            />
                        </div>
                        </Col>
                    </Row>
                </Form>
                <Row>
                    <Col>
                        <div className={classes.HashtagInput} hidden={this.state.useContactMethodOption? '':'hidden'}>
                        <ReactTags tags={tags}
                            suggestions={suggestions}
                            placeholder="Add new method"
                            handleDelete={this.handleDelete}
                            handleAddition={this.handleAddition}
                            handleDrag={this.handleDrag}
                            delimiters={delimiters} />
                        </div>
                    </Col>
                </Row>
                </div>

                <div className={classes.ConfirmBlock}>
                <Row className={classes.ConfirmBlockOption}>
                    <Col>
                    <Button block variant="info" size={inputSize} onClick={this.handleSave}>Save My Changes</Button>
                    </Col>
                </Row>
                <Row className={classes.ConfirmBlockOption}>
                    <Col>
                    <Button block variant="outline-info" size={inputSize} onClick={this.handleViewCalendar}>View My Calendar</Button>
                    </Col>
                </Row>
                <Row className={classes.ConfirmBlockOption}>
                    <Col>
                    <TextLink link='/profile/' text='Back to Profile'></TextLink>
                    </Col>
                </Row>
                </div>

                </Container>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        authToken: state.auth.token
    };
};

export default connect( mapStateToProps ) (CalendarManagement);


// WEBPACK FOOTER //
// ./src/containers/CelendarManagement/CalendarManagement.js